import { LandscapeCommoditySaveRequestDto } from '../../../landscapeAPI/landscape/dto/request/landscape-commodity-save-request.dto';
import { LandscapeCommodityUpdateRequestDto } from '../../../landscapeAPI/landscape/dto/request/landscape-commodity-update-request.dto';
import { LandscapeCommodityResponseDto } from '../../../landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';
import { BaseTradeService } from '../../base-trade.service';

class CommodityLandscapeService extends BaseTradeService {
  public async fetchCommoditiesByLandscapeId(
    compactId: string
  ): Promise<LandscapeCommodityResponseDto[]> {
    const response = await this.get<LandscapeCommodityResponseDto[]>(
      `/compactcommodity/getbycompactid/${compactId}`
    );
    return response.data;
  }

  public async fetchCommodityLandscapeById(
    id: string
  ): Promise<LandscapeCommodityResponseDto> {
    const response = await this.get<LandscapeCommodityResponseDto>(
      `/compactcommodity/${id}`
    );
    return response.data;
  }

  public async saveCommodityLandscape(
    saveRequest: LandscapeCommoditySaveRequestDto
  ): Promise<LandscapeCommodityResponseDto> {
    const response = await this.post<LandscapeCommodityResponseDto>(
      `/compactcommodity`,
      saveRequest
    );
    return response.data;
  }

  public async updateCommodityLandscape(
    updateRequest: LandscapeCommodityUpdateRequestDto
  ): Promise<LandscapeCommodityResponseDto> {
    const response = await this.put<LandscapeCommodityResponseDto>(
      `/compactcommodity`,
      updateRequest
    );
    return response.data;
  }

  public async deleteCommodityLandscape(
    id: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/compactcommodity/${id}`, {
      params: {
        compactId,
      },
    });
  }
}

const commodityLandscapeService = new CommodityLandscapeService();
export default commodityLandscapeService;
